import React, { useEffect, useState } from 'react';
import { DataService } from '../services/DataService';
import { hideRightPanel, openLeftPanel, openRightPanel } from '../services/UIServices';

const SearchResults = (props) => {
    // Extracting necessary data from jsondata
    const { onItemSelected, selectedRoute, onFilterChanged } = props;
    const [flightsList, setFlightsList] = useState([]);
    const [filterInfo, setFilterInfo] = useState({ stopscount: [] });
    // console.log(data)
    useEffect(() => {
        //console.log(routeInfo)
        getRouteData();
    }, [props])

    const getRouteData = async () => {
        // console.log("selectedRoute", selectedRoute)
        var layoverCodes = null;
        if (selectedRoute.layovers != null && selectedRoute.layovers.length > 0) {
            var layoverCodes = selectedRoute.layovers.map(l => {
                if (l.Code != selectedRoute.originCode && l.Code != selectedRoute.destinationCode) {
                    return l.Code;
                }
            }).filter(x => x != null)
        }
        var jsondata = await new DataService().getRouteData(selectedRoute.originCode, selectedRoute.destinationCode, layoverCodes, filterInfo);
        console.log("jsondata", jsondata)
        setFlightsList(jsondata);

        // jsondata = jsondata.slice(0, 9);

    }

    const setFilters = async (e, stopscount) => {
        //alert(stopscount)
        if (e.target.checked) {
            filterInfo.stopscount.push(stopscount)
        }
        if (!e.target.checked) {
            var ind = filterInfo.stopscount.indexOf(stopscount);
            filterInfo.stopscount.splice(ind, 1)
        }
        setFilterInfo(filterInfo);
        onFilterChanged(filterInfo);
    }

    const clearAll = () => {
        filterInfo.stopscount = [];
        unCheck();
        setFilterInfo(filterInfo);
        onFilterChanged(filterInfo);
    }

    function unCheck() {
        var x = document.querySelectorAll('input[type=checkbox]');
        for (var i = 0; i < x.length; i++) {
            x[i].checked = false;
        }
    }

    return (<>

        <section className="ftco-section ftco-section2">
            <div className="container">
                <div className="row justify-content-center">
                    <button onClick={() => {
                        hideRightPanel();
                    }} className='btn btn-primary'>X</button>
                    <div className="col-md heading-section text-center">
                        {/* <span className="subheading">Available Frights</span> */}
                        <h6 className="mb-2 mt-2" style={{ fontSize: '12px' }}> {selectedRoute.origin}({selectedRoute.originCode}) - {selectedRoute.destination}({selectedRoute.destinationCode})</h6>
                        <h6 className="mb-2 mt-2" style={{ fontSize: '12px' }}>{selectedRoute && selectedRoute.layovers && selectedRoute.layovers.map((x, i) => {

                            if (i == 0) {
                                return <>Layover:</>
                            }
                            if (i > 0 && i < selectedRoute.layovers.length - 1) {
                                return <> {x.City}({x.Code})</>
                            }
                        }
                        )}
                        </h6>
                    </div>
                </div>
            </div>
        </section>
        <section className="ftco-section ftco-section2">
            <div className="container container-scroll">
                {/* <div className="row justify-content-center pb-4">
                    <div className="col-md-12 heading-section text-center ">
                        <span className="subheading">Available Frights</span>
                        <h6 className="mb-4">Flights in the selected route</h6>
                    </div>
                </div> */}
                <div className='row'>
                    <div className="col-md ">
                        <div className="form-group border-0">
                            <div className='days'><p>No of stops</p></div>
                            <div className="form-field pull-left">
                                <input type="checkbox" valule="0" onChange={(e) => setFilters(e, '0')} /> Non Stop
                            </div>
                            <div className="form-field pull-left" style={{ marginLeft: '10px' }}>
                                <input type="checkbox" valule="1" onChange={(e) => setFilters(e, '1')} /> 1
                            </div>
                            <div className="form-field pull-left ms-2" style={{ marginLeft: '10px' }}>
                                <input type="checkbox" valule="2" onChange={(e) => setFilters(e, '2')} /> 2
                            </div>
                            <div className="form-field pull-left ms-2" style={{ marginLeft: '10px' }}>
                                <input type="checkbox" valule="2+" onChange={(e) => setFilters(e, '2+')} /> 2+
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row' style={{ borderBottom: '1px solid #ddd' }}>
                    <div className="col-md ">
                        <div className="form-group border-0  pull-right">

                            <div className="form-field pull-left">
                                <a href='javascript:;' onClick={clearAll}>Clear All</a>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-md-12 ">
                        {flightsList ? flightsList.map((jd, i) => {
                            var flInfo = jd;
                            return (<div className="project-wrap pwmb" key={i}>
                                <a
                                    onClick={() => onItemSelected(flInfo)}
                                >
                                    <div className="text p-2">
                                        <div className="days">Flight: {flInfo.OriginLocation} - {flInfo.DestinationLocation}</div>
                                        {flInfo.FlightSegment.map((segment, segIndex) => (
                                            <p key={segIndex}>
                                                Layover at {segment.LayoverAirport}
                                            </p>
                                        ))}

                                        <p>DEP: {new Date(flInfo.DepartureTime).toLocaleString()} - ARI: {new Date(flInfo.ArrivalTime).toLocaleString()}</p>
                                        <p className="location"><span className="fa fa-map-marker"></span> Price:{flInfo.FlightDetails.PriceDetails.Currency} {flInfo.FlightDetails.PriceDetails.TotalFare}</p>
                                        {/* <ul>
                                    <li><span className="flaticon-shower"></span>2</li>
                                    <li><span className="flaticon-king-size"></span>3</li>
                                    <li><span className="flaticon-mountains"></span>Near Mountain</li>
                                </ul> */}
                                    </div>
                                </a>
                            </div>)
                        }) : (<>No flights found</>)
                        }
                    </div>

                </div>
            </div>
        </section>
    </>

    );
};

export default SearchResults;
